import { Navigate } from "react-router-dom";

// Authentication
import Fourzerofour from "pages/AuthenticationInner/Errors/404Error";
import Fivezerozero from "pages/AuthenticationInner/Errors/500Error";
import Fivezerothree from "pages/AuthenticationInner/Errors/503Error";
import OfflinePage from "pages/AuthenticationInner/Errors/Offline";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import Register from "pages/Authentication/Register";
import UserProfile from "pages/Authentication/user-profile";
import CreateUserForm from "pages/UserManagement/User/Form/UserForm";
import { OverviewDashboard } from "pages/Dashboard/Index";
import AllRoutes from "./Routes";
import MainListing from "pages/TagsSearchPage/MainListingPage/MainListing";
import TagDispatchViewDetails from "pages/TagsSearchPage/DispatchListing/View/ViewDispatch";
import TagApprovedPRViewDetails from "pages/TagsSearchPage/PurchaseOrderListing/View/ApprovedPRViewDetails";
import TagPurchaseOrderDetails from "pages/TagsSearchPage/PurchaseOrderListing/View/PurchaseOrderDetails";
import ProductEnquiryViewV2 from "pages/TagsSearchPage/EnquiryListing/View/ProductEnquiryViewV2";
import ServiceEnquiryViewV2 from "pages/TagsSearchPage/EnquiryListing/View/ServiceEnquiryViewV2";
import ViewProductQuotation from "pages/TagsSearchPage/QuotationListing/SalesListing/Product/ViewProductQuotation";
import ViewServiceQuotation from "pages/TagsSearchPage/QuotationListing/ServiceListing/Service/ViewServiceQuotation";
import ViewSalesOrderPage from "pages/TagsSearchPage/OrderListing/SalesListing/View/ViewSalesOrderPage";
import ViewServiceSalesOrderPage from "pages/TagsSearchPage/OrderListing/ServiceListing/View/ViewServiceSalesOrderPage";
import WarehousePackingDoneViewDetails from "pages/Warehouse/Packing/WarehousePackingDoneViewDetails";
import PurchaseRequestViewDetails from "pages/TagsSearchPage/PurchaseRequest/ViewDetails/ViewDetails";

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <OverviewDashboard /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },

  // User Profile
  { path: "/user-profile", name: "UserProfile", component: <UserProfile /> },

  // Tags Search (same layout as other listing pages: sidebar + header)
  { path: "/tags-search/:tags", name: "TagsSearch", component: <MainListing /> },
  {
    path: "/tags-search/dispatch-view-details/:dispatch_id",
    name: "TagDispatchViewDetails",
    component: <TagDispatchViewDetails />,
  },
  {
    path: "/tags-search/purchase-request-approved-pr-view-details/:pr_id",
    name: "TagApprovedPRViewDetails",
    component: <TagApprovedPRViewDetails />,
  },
  {
    path: "/tags-search/purchase-request-view-details/:pr_id",
    name: "TagPurchaseRequestViewDetails",
    component: <PurchaseRequestViewDetails />,
  },
  {
    path: "/tags-search/purchase-order-view-details/:po_id",
    name: "TagPurchaseOrderDetails",
    component: <TagPurchaseOrderDetails />,
  },
  {
    path: "/tags-search/enquiry/product/enquiry_log/view/:id",
    name: "TagProductEnquiryView",
    component: <ProductEnquiryViewV2 />,
  },
  {
    path: "/tags-search/enquiry/service/enquiry_log/view/:id",
    name: "TagServiceEnquiryView",
    component: <ServiceEnquiryViewV2 />,
  },
  {
    path: "/tags-search/quotation/product/view/:id",
    name: "TagProductQuotationView",
    component: <ViewProductQuotation />,
  },
  {
    path: "/tags-search/quotation/service/view/:id",
    name: "TagServiceQuotationView",
    component: <ViewServiceQuotation />,
  },
  {
    path: "/tags-search/sales_order/product/:activeTab/view/:id",
    name: "TagProductSalesOrderView",
    component: <ViewSalesOrderPage />,
  },
  {
    path: "/tags-search/sales_order/service/:activeTab/view/:id",
    name: "TagServiceSalesOrderView",
    component: <ViewServiceSalesOrderPage />,
  },
  {
    path: "/tags-search/warehouse-packing-done-view-details/:id",
    name: "TagPackingDoneViewDetails",
    component: <WarehousePackingDoneViewDetails />,
  },

  ...AllRoutes,
];

const publicRoutes = [
  // Authentication
  { path: "/login", name: "Login", component: <Login /> },
  { path: "/logout", name: "Logout", component: <Logout /> },
  { path: "/register", name: "Register", component: <Register /> },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: <ForgotPassword />,
  },
  // Users Masters for creating new user
  {
    path: "/create-users",
    name: "Ecommerce Create Product",
    component: <CreateUserForm />,
  },
  // Error 404
  { path: "/auth-404", name: "Fourzerofour", component: <Fourzerofour /> },

  // Error 500
  { path: "/auth-500", name: "Fivezerozero", component: <Fivezerozero /> },

  // Error 503
  { path: "/auth-503", name: "Fivezerothree", component: <Fivezerothree /> },

  // Offline Page
  { path: "/auth-offline", name: "OfflinePage", component: <OfflinePage /> },
];

export { authProtectedRoutes, publicRoutes };
